import Vue from 'vue/dist/vue.esm'

Vue.component(
  "novelties-list-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/NoveltiesList")
)

Vue.component(
  'documents-detail-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/documents/Detail")
)
Vue.component(
  'documents-search-bar-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/documents/SearchBar")
)
Vue.component(
  'documents-options-button-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/documents/OptionsButton")
)
Vue.component(
  'documents-font-size-button-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/documents/FontSizeButton")
)
Vue.component(
  "hubs-filters-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/hubs/Filters")
)
Vue.component(
  "hubs-expand-button-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/hubs/ExpandButton")
)
Vue.component(
  "document-card-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/documents/DocumentCard")
)
Vue.component(
  "documents-concepts-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/documents/Concepts")
)